import React, { useState, useEffect } from 'react';

import { useNavigate, useLocation, Link } from 'react-router-dom';

import { getPurchaseSites } from '../../services/purchaseSitesService';

import { getPurchaseSiteMigrationSummary } from '../../services/purchaseSiteMigrationService';

import { useComprasPurchaseSite } from '../../contexts/ComprasPurchaseSiteContext';

import { authService } from '../../services/authService';

import { filterPurchaseSitesForUser } from '../../utils/limitedUserAccess';

import Toast from '../../components/Common/Toast';



const SelectPurchaseSite = () => {

  const navigate = useNavigate();

  const location = useLocation();

  const {

    selectedPurchaseSite,

    isWithoutSiteMode,

    setSelectedPurchaseSite,

    selectWithoutSiteMode,

  } = useComprasPurchaseSite();

  const [sites, setSites] = useState([]);

  const [withoutCount, setWithoutCount] = useState(null);

  const [loading, setLoading] = useState(true);

  const [searchTerm, setSearchTerm] = useState('');

  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });



  const returnPath =

    typeof location.state?.from === 'string' &&

    (location.state.from.startsWith('/purchase-orders') ||

      location.state.from.startsWith('/service-orders') ||

      location.state.from.startsWith('/requirements') ||

      location.state.from.startsWith('/documents') ||

      location.state.from.startsWith('/supply-continuous') ||

      location.state.from.startsWith('/continuous-services') ||

      location.state.from.startsWith('/compras/purchase-site-assignment'))

      ? location.state.from

      : '/purchase-orders';



  useEffect(() => {

    let cancelled = false;

    (async () => {

      try {

        setLoading(true);

        const [sitesRes, summaryRes] = await Promise.all([

          getPurchaseSites({ active_only: true }),

          getPurchaseSiteMigrationSummary(),

        ]);

        if (!cancelled && sitesRes.success) {

          const user = authService.getCurrentUser();

          const active = (sitesRes.data || []).filter((s) => s.is_active !== false);

          setSites(filterPurchaseSitesForUser(active, user));

        }

        if (!cancelled && summaryRes.success) {

          setWithoutCount(summaryRes.data?.without_total ?? 0);

        }

      } catch {

        if (!cancelled) {

          setToast({ isOpen: true, message: 'Error al cargar sedes de compra', type: 'error' });

        }

      } finally {

        if (!cancelled) setLoading(false);

      }

    })();

    return () => {

      cancelled = true;

    };

  }, []);



  const handleSelect = (site) => {

    setSelectedPurchaseSite(site);

    navigate(returnPath, { replace: true, state: { siteConfirmed: true } });

  };



  const handleSelectWithoutSite = () => {

    selectWithoutSiteMode();

    navigate(returnPath, { replace: true, state: { siteConfirmed: true } });

  };



  const filtered = sites.filter(

    (s) =>

      !searchTerm ||

      (s.name || '').toLowerCase().includes(searchTerm.toLowerCase()) ||

      (s.code || '').toLowerCase().includes(searchTerm.toLowerCase())

  );



  const showWithoutCard =

    !searchTerm ||

    'sin sede'.includes(searchTerm.toLowerCase()) ||

    'documento'.includes(searchTerm.toLowerCase()) ||

    'historico'.includes(searchTerm.toLowerCase());



  const warehouseLabel = (site) => {

    const list = site.warehouses || [];

    if (!list.length) return 'Sin almacenes';

    return list.map((w) => (w.code ? `${w.code}` : w.name)).join(', ');

  };



  return (

    <div className="p-6">

      <div className="max-w-6xl mx-auto">

        <div className="mb-6 flex flex-wrap items-start justify-between gap-4">

          <div>

            <h1 className="text-3xl font-bold text-gray-800">Sede de compra</h1>

            <p className="text-gray-600 mt-1 max-w-2xl">

              Elija la sede con la que trabajará en órdenes y documentos de compra, o entre a la

              sección de documentos históricos sin sede asignada.

            </p>

            {isWithoutSiteMode ? (

              <p className="text-sm text-amber-700 mt-2">

                Actual: <strong>Documentos sin sede</strong>

              </p>

            ) : selectedPurchaseSite?.id ? (

              <p className="text-sm text-teal-700 mt-2">

                Actual:{' '}

                <strong>

                  {selectedPurchaseSite.code ? `${selectedPurchaseSite.code} — ` : ''}

                  {selectedPurchaseSite.name}

                </strong>

              </p>

            ) : null}

          </div>

          <Link

            to={returnPath}

            className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 text-sm font-medium"

          >

            Volver

          </Link>

        </div>



        <div className="bg-white rounded-lg shadow-md p-5 mb-6">

          <input

            type="text"

            placeholder="Buscar por código o nombre..."

            value={searchTerm}

            onChange={(e) => setSearchTerm(e.target.value)}

            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"

          />

        </div>



        {loading ? (

          <div className="text-center py-12 bg-white rounded-lg shadow-md text-gray-500">

            Cargando…

          </div>

        ) : (

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">

            {showWithoutCard && (

              <button

                type="button"

                onClick={handleSelectWithoutSite}

                className={`text-left rounded-lg shadow-md border-2 p-5 hover:shadow-lg transition-all md:col-span-2 lg:col-span-3 ${
                  isWithoutSiteMode
                    ? 'bg-amber-100 border-amber-500 ring-2 ring-amber-400'
                    : 'bg-amber-50 border-amber-300 hover:border-amber-500'
                }`}

              >

                <div className="flex flex-wrap items-center gap-2">

                  <p className="font-semibold text-amber-900 text-lg">Documentos sin sede</p>

                  <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-amber-200 text-amber-900">

                    Por defecto

                  </span>

                </div>

                <p className="text-sm text-amber-800 mt-1">

                  Histórico de compras pendiente de asignar a una sede

                  {withoutCount != null ? ` — ${withoutCount} documento(s)` : ''}.

                </p>

                <p className="text-xs text-amber-700 mt-2">

                  Use esta opción para revisar y asignar órdenes, requisiciones y facturas antiguas.

                  Las guías de ingreso no se incluyen (ya están en su almacén).

                </p>

              </button>

            )}



            {filtered.length === 0 && !showWithoutCard ? (

              <div className="col-span-full text-center py-12 bg-white rounded-lg shadow-md text-gray-500">

                No hay sedes que coincidan con la búsqueda.

              </div>

            ) : (

              filtered.map((site) => (

                <button

                  key={site.id}

                  type="button"

                  onClick={() => handleSelect(site)}

                  className={`text-left rounded-lg shadow-md border p-5 hover:shadow-lg transition-all ${
                    selectedPurchaseSite?.id === site.id
                      ? 'bg-teal-50 border-teal-500 ring-2 ring-teal-300'
                      : 'bg-white border-gray-200 hover:border-teal-400'
                  }`}

                >

                  <p className="font-semibold text-gray-900">{site.name}</p>

                  {site.code ? <p className="text-sm text-gray-500 mt-1">{site.code}</p> : null}

                  <p className="text-xs text-gray-500 mt-2">Almacenes: {warehouseLabel(site)}</p>

                </button>

              ))

            )}

          </div>

        )}

      </div>

      <Toast

        isOpen={toast.isOpen}

        message={toast.message}

        type={toast.type}

        onClose={() => setToast({ ...toast, isOpen: false })}

      />

    </div>

  );

};



export default SelectPurchaseSite;


